import { project } from "./projection";
import { nodeWidth } from "./scoring";

// Force-directed separation so nodes in dense areas (e.g. the Northeast) spread
// apart enough to be individually selectable, while remembering their true
// geographic coordinates (for leader lines).
export function computeLayout(institutions) {
  const nodes = institutions.map((i) => {
    const [x, z] = project(i.lng, i.lat);
    return { rank: i.rank, ox: x, oz: z, dx: x, dz: z, r: nodeWidth(i) * 0.8 };
  });

  // Separation gap scales down as the dataset grows so a large, dense list
  // (100 schools) still resolves without sprawling across the whole map.
  const gap = nodes.length > 60 ? 0.32 : 0.4;
  const iterations = nodes.length > 60 ? 420 : 220;
  // Light anchor spring pulling each node back toward its true coordinate so
  // dense clusters (Northeast) expand locally instead of drifting off-region.
  const anchor = 0.03;

  for (let iter = 0; iter < iterations; iter++) {
    for (let a = 0; a < nodes.length; a++) {
      for (let b = a + 1; b < nodes.length; b++) {
        const A = nodes[a];
        const B = nodes[b];
        let ddx = A.dx - B.dx;
        let ddz = A.dz - B.dz;
        let d = Math.hypot(ddx, ddz);
        if (d < 1e-4) {
          ddx = (Math.sin(a * 12.9) ) * 0.01;
          ddz = (Math.cos(b * 7.3)) * 0.01;
          d = Math.hypot(ddx, ddz) || 0.01;
        }
        const min = A.r + B.r + gap;
        if (d < min) {
          const push = (min - d) / 2;
          const ux = ddx / d;
          const uz = ddz / d;
          A.dx += ux * push;
          A.dz += uz * push;
          B.dx -= ux * push;
          B.dz -= uz * push;
        }
      }
    }
    // Anchor pass keeps the overall footprint tied to real geography.
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i];
      n.dx += (n.ox - n.dx) * anchor;
      n.dz += (n.oz - n.dz) * anchor;
    }
  }

  const map = {};
  nodes.forEach((n) => (map[n.rank] = n));
  return map;
}
